import React from 'react';
import { AppButton } from "../index";

import AgentIcon from "../../assets/images/ai-assistant-icon2.svg";
import ChatIcon from "../../assets/images/live-chat-icon.svg";
// import CrossIcon from "../../assets/images/cross-icon.svg"
import ClearIcon from '@mui/icons-material/Clear';

interface LiveChatButtonProps {
  isActive: boolean;
  onClick: () => void;
  agent?: boolean
}

const LiveChatButton: React.FC<LiveChatButtonProps> = ({ isActive, onClick, agent }) => {
  return (
    <AppButton variant="contained" color="warning"
      sx={{ borderRadius: '100px', fontSize: 18, fontWeight: 'bold', minHeight: '60px !important' }}
      onClick={onClick}
      className={`${isActive ? ' ' : 'live-chat-btn'}`}
    >
      {isActive ? (
        <>
          {/* <img src="/images/live-chat-icon.svg" alt="Chat Icon" /> */}
          {agent ?
            (<div>
              <img src={AgentIcon} alt="Chat Icon" />
              &nbsp;&nbsp;AI Assistant
            </div>) :
            (<div>
              <img src={ChatIcon} alt="Chat Icon" />
              &nbsp;&nbsp;Chat
            </div>)
          }
        </>
      ) : (
        <>
          <ClearIcon color='inherit' fontSize="large"/>
        </>
      )}
    </AppButton>
  );
};

export default LiveChatButton; 